var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ubox-button ubox-button-primary",attrs:{"type":"submit"},on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_c('span',[_vm._v("这是一个按钮")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }